export const staffUserQueryKeys = { getStaffUserQuery: 'getStaffUser' };
export const monthlyStatementQueryKeys = {
  getMonthlyStatements: 'getMonthlyStatements',
  downloadMonthlyStatement: 'downloadMonthlyStatement',
};
export const driverQueryKeys = {
  getDriversQuery: 'getDriversQuery',
};

export const corporationQueryKeys = {
  getCorporationsQuery: 'getCorporationsQuery',
  getBillingInformationQuery: 'getBillingInformationQuery',
};

export const auditLogsQueryKeys = {
  getAuditLogsQuery: 'getAuditLogsQuery',
};

export const paymentQueryKeys = {
  getPaymentMethodsQuery: 'getPaymentMethodsQuery',
};

export const walletQueryKeys = {
  getWalletQuery: 'getWalletQuery',
  pollCardLoadQuery: 'pollCardLoadQuery',
};

export const wireTransferQueryKeys = {
  getWireTransfersQuery: 'getWireTransfersQuery',
  downloadWireTransferProofQuery: 'downloadWireTransferProofQuery',
};

export default {
  driverQueryKeys,
  paymentQueryKeys,
  staffUserQueryKeys,
  monthlyStatementQueryKeys,
  corporationQueryKeys,
  walletQueryKeys,
  wireTransferQueryKeys,
};
